// ProductsTableRow.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import MutableListItemOptions from '../MutableListItemOptions';
import { StoreProduct } from '../../models/StoreProduct';

interface ComponentProps {
  storeProduct: StoreProduct;
  onEditProduct: (product: StoreProduct) => void /* eslint-disable-line */;
  onRemoveProduct: (product: StoreProduct) => void /* eslint-disable-line */;
}

const ProductsTableRow = ({
  storeProduct,
  onEditProduct,
  onRemoveProduct,
}: ComponentProps) => {
  return (
    <TableRow>
      <TableTd>
        <ProductData>
          <Link to={`/product-details/${storeProduct.id}`} className="link">
            <img src={storeProduct.imageUrl} width={50} height={50} />
          </Link>
        </ProductData>
      </TableTd>
      <TableTd>
        <ProductData title={storeProduct.description}>
          {storeProduct.name}
        </ProductData>
      </TableTd>
      {/* <TableTd>
        <PlainData title={storeProduct.description}>
          {storeProduct.description.length > 20
            ? `${storeProduct.description.slice(0, 20)}...`
            : storeProduct.description}
        </PlainData>
      </TableTd> */}
      <TableTd>
        <PlainData>{storeProduct.price}</PlainData>
      </TableTd>
      <TableTd>
        <PlainData>R$ {storeProduct.cashPrice}</PlainData>
      </TableTd>
      <TableTd>
        <PlainData>{storeProduct.stockQuantity}</PlainData>
      </TableTd>
      <TableTd>
        <PlainData title={storeProduct.tags}>
          {storeProduct.tags.length > 20
            ? `${storeProduct.tags.slice(0, 20)}...`
            : storeProduct.tags}
        </PlainData>
      </TableTd>
      {/* <TableTd>
        <DateContainer>{formatDate(storeProduct.createdAt)}</DateContainer>
      </TableTd> */}
      <TableTd>
        <MutableListItemOptions
          objectName={storeProduct.name}
          onEdit={() => onEditProduct(storeProduct)}
          onRemove={() => onRemoveProduct(storeProduct)}
        />
      </TableTd>
    </TableRow>
  );
};

export const TableTd = styled.td`
  padding: 1.25rem 1rem;
  border-bottom: 1px solid #e0e0e0;
`;

export const TableRow = styled.tr`
  gap: 1.5rem;
`;

export const ProductData = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;

  img {
    border-radius: 4px;
    object-fit: cover;
  }

  .link {
    text-decoration: none;

    .primary-data {
      font-weight: 500;
      margin: 0;
    }

    p {
      margin: 0;
    }
  }
`;

export const PlainData = styled.p`
  margin: 0;
`;

export const DateContainer = styled.div`
  font-size: 0.75rem;
`;

export default ProductsTableRow;
